import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/gear-solid.svg'
import _imports_1 from '../assets/drop-silhouette.png'
import _imports_2 from '../assets/wind-solid.svg'


const _hoisted_1 = { class: "widget" }
const _hoisted_2 = { class: "widget__menu" }
const _hoisted_3 = { class: "widget__city" }
const _hoisted_4 = { class: "widget__city-name" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "widget__settings-img",
  src: _imports_0,
  alt: "gear"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "widget__temp" }
const _hoisted_8 = { class: "widget__temp-row" }
const _hoisted_9 = { class: "widget__weather-description" }
const _hoisted_10 = { class: "widget__temp-row" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "widget__display-temp" }
const _hoisted_13 = { class: "widget__weather-params" }
const _hoisted_14 = { class: "widget__weather-params-item" }
const _hoisted_15 = { class: "widget__weather-params-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  class: "widget__weather-img",
  src: _imports_1,
  alt: "humidity"
}, null, -1)
const _hoisted_17 = { class: "widget__weather-params-item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  class: "widget__weather-img",
  src: _imports_2,
  alt: "wind speed"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cities.filter((c, i) => i === 0), (city) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: city.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(city.city), 1),
            _createTextVNode(", " + _toDisplayString(city.country), 1)
          ]),
          _createElementVNode("button", {
            class: "widget__settings-btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showWidget')))
          }, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(city.desc), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "widget__temp-img",
              src: _ctx.getIconSrc(city.icon),
              alt: `${city.desc}`
            }, null, 8, _hoisted_11),
            _createElementVNode("div", _hoisted_12, _toDisplayString(city.temp) + "°", 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, "feels like: " + _toDisplayString(city.feels_like) + "°", 1),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(city.humidity) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("span", null, _toDisplayString(city.wind) + " m/s", 1)
          ])
        ])
      ], 64))
    }), 128))
  ]))
}